// extracted by mini-css-extract-plugin
export default {"previewImage":"template-preview_previewImage__k9Vp7"};